// extracted by mini-css-extract-plugin
export default {"f":"_5646ae0c83","main":"_1fdedf552d","btn":"b7fc2a9bdf","w":"a9a06d84ef","h":"_0a968cf0e6","lh25":"_7fd7a360ad","wb":"_3fdaa666c0","b":"e8fefeb0b6","bx":"_760efdac82"};